import axios from 'axios';

import ENDPOINTS from 'tradera/constants/endpoints';
import { finalizeResponse, handleError, logError } from 'tradera/utils/api';
import { removeBannedCountries } from 'tradera/localization/countries';

export const fetchAvailableShippingCountries = () =>
    axios
        .get(ENDPOINTS.AVAILABLE_SHIPPING_COUNTRIES)
        .then(finalizeResponse())
        .then(({ data }) => ({
            shippingCountries: data.availableCountries
                .map((country) => ({
                    countryCodeIso2: country.countryCodeIso2.toLowerCase(),
                    countryNameEng: country.countryNameEng,
                }))
                .filter(removeBannedCountries),
        }))
        .catch(handleError())
        .catch(logError);
